
<div class="sidebarbody">
  <ng-content select="[sidebar-body]" />
</div>

<footer>
  <div class="row sidebarfooter">
    <ng-content select="[sidebar-footer]" />
  </div>
</footer>

@if (showSidebar() && displayMask()) {
  <div class="sidebar-mask"></div>
}